var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIAvnQuestionMark = function SvgIAvnQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.645 5.052C.65 2.676 2.533.65 4.738.65s4.07 2.01 3.901 4.37v.012c-.043 1.032-.301 1.657-.668 2.156-.366.5-.861.873-1.393 1.318-1.066.893-1.928 1.643-1.928 4.644",
    stroke: "#002774",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    "data-no-fill": "true"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.65,
    cy: 16.65,
    r: 1,
    fill: "#002774",
    "data-no-stroke": "true"
  })));
};
export { SvgIAvnQuestionMark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTAgMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aAogICAgICAgIGQ9Ik0wLjY0NSA1LjA1MTc2QzAuNjQ5OTk0IDIuNjc1ODcgMi41MzI1MiAwLjY1MDAyNCA0LjczNzY2IDAuNjUwMDI0QzYuOTQyOCAwLjY1MDAyNCA4LjgwODI1IDIuNjU5NzcgOC42MzkzNSA1LjAxOTU3VjUuMDMxNjRDOC41OTU3MSA2LjA2MzY3IDguMzM3NjIgNi42ODkzMyA3Ljk3MTM2IDcuMTg4MjVDNy42MDUxIDcuNjg3MTYgNy4xMDk4IDguMDYxMzUgNi41Nzg0NCA4LjUwNTk1QzUuNTExOTMgOS4zOTkxNyA0LjY0OTk5IDEwLjE0ODUgNC42NSAxMy4xNSIKICAgICAgICBzdHJva2U9IiMwMDI3NzQiCiAgICAgICAgc3Ryb2tlLXdpZHRoPSIxLjMiCiAgICAgICAgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIgogICAgICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgICAgICBkYXRhLW5vLWZpbGw9InRydWUiCiAgICAvPgogICAgPGNpcmNsZSBjeD0iNC42NSIgY3k9IjE2LjY1IiByPSIxIiBmaWxsPSIjMDAyNzc0IiBkYXRhLW5vLXN0cm9rZT0idHJ1ZSIvPgo8L3N2Zz4=";